import { Avatar, Box, Table, Text } from '@factorialco/deprecated-design-system'
import { AccessForSelectFragment } from 'generated/resources/graphql'

import { AccessSelector } from 'modules/core/components/AccessSelector'
import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  selectedAccesses: AccessForSelectFragment[] | undefined
  handleSelectAccesses: (newAccesses: AccessForSelectFragment[]) => void
}

export const BankAccountMembershipSelector = ({
  selectedAccesses,
  handleSelectAccesses,
}: Props) => {
  return (
    <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
      <AccessSelector
        width="s400"
        onSelect={handleSelectAccesses}
        multiple
        value={selectedAccesses}
      />

      {selectedAccesses && selectedAccesses.length > 0 && (
        <Table autoLayout>
          <Table.Head>
            <Table.Row>
              <Table.HeadCell>Employees</Table.HeadCell>
            </Table.Row>
          </Table.Head>
          {selectedAccesses.map((access) => (
            <Table.Row key={`access-${access.id}`}>
              <Table.Cell noBorder width={108} paddingX="s4">
                <Box style={{ paddingLeft: '20px' }}>
                  <Box flexDirection="row" alignItems="center" gap="s16">
                    <Avatar label={access.fullName} url={buildUrl(access.avatar)} size="s40" />
                    <Text.Normal>{access.fullName}</Text.Normal>
                  </Box>
                </Box>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table>
      )}
    </Box>
  )
}
